<template>
  <v-tabs v-model="currentOffer" show-arrows dark>
    <v-tab v-for="(offer, i) in offers" :key="i" ripple
      >Aanbieding ID {{ offer.id }}
    </v-tab>
    <v-tab-item v-for="(offer, i) in offers" :key="i">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="pa-0" flat>
            <v-card-text>
              <div>
                <strong>Dossier nr: {{ offer.casenumber }}</strong>
              </div>
              <div>
                Door: <strong>{{ offer.name }}</strong>
              </div>
              <br />
              <div>
                Zorgtraject: <strong>{{ offer.formtype }}</strong>
              </div>
              <div>
                Aangeboden per: <strong>{{ offer.published_at }}</strong>
              </div>
              <br />
              <div>
                <strong>Diagnostiek:</strong>
                <ul>
                  <li v-for="diagnostic in offer.diagnostics">
                    {{ diagnostic }}
                  </li>
                </ul>
              </div>
              <br />
              <div>
                <strong>Behandeling:</strong>
                <ul>
                  <li v-for="treatment in offer.treatments">
                    {{ treatment }}
                  </li>
                </ul>
              </div>
              <br />
              <div>
                Tijdsindicatie: <strong>{{ offer.effort }}</strong>
              </div>
              <div>Locatie: {{ offer.address }}</div>
              <br />
              <div>Toelichting<br />{{ offer.notes }}</div>
            </v-card-text>
            <v-card-actions>
              <slot name="buttons"></slot>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    offers: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentOffer: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
</script>
